import { render, staticRenderFns } from "./component_name_token.vue?vue&type=template&id=272a7ae7"
import script from "./component_name_token.vue?vue&type=script&lang=js"
export * from "./component_name_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports